module.exports = __webpack_public_path__ + "assets/webcam.swf";


//////////////////
// WEBPACK FOOTER
// ../node_modules/webcamjs/webcam.swf
// module id = 1170
// module chunks = 0